import AntForm from 'antd/lib/form';

export const Form = AntForm;

export const useForm = Form.useForm;
